import React from 'react';

import {AttachTooltip} from 'app/general/overlays/AttachTooltip';
import {gt} from 'app/utils/i18n';

import {TaggedItemSerializedType, TagSerializedType} from 'sweet-types';
type Props = {
  tags?: Array<TaggedItemSerializedType | TagSerializedType>;
  showNoEditMessage: boolean;
};
export const DocumentTagsList = ({
  tags,
  showNoEditMessage,
}: Props): JSX.Element | null => {
  if (tags == null || tags.length === 0) {
    return null;
  }

  const tagsList = tags.map((tag) => (
    <span key={tag.url}>
      <span className="badge badge-secondary">{tag.name}</span>{' '}
    </span>
  ));
  return (
    <div className="form-group">
      {showNoEditMessage ? (
        <AttachTooltip
          placement="bottom"
          tooltipContent={gt('Only managers can edit tags')}
        >
          {(handlers) => <span {...handlers}>{tagsList}</span>}
        </AttachTooltip>
      ) : (
        tagsList
      )}
    </div>
  );
};
DocumentTagsList.defaultProps = {
  showNoEditMessage: false,
};
